
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { CommonStore, MapStore, BlockStore } from '@/store/modules';
import { CropVariety } from '@/store/models/block';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect
  }
})
export default class CropForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get cropTypes() {
    return BlockStore.CropTypes.map(x => {
      return { value: x.id, label: `${x.name}` };
    });
  }

  get emptyCropVariety() {
    return BlockStore.emptyCropVariety;
  }

  get cropVariety() {
    return JSON.parse(JSON.stringify(BlockStore.AddEditCropVariety));
  }

  set cropVariety(cropVariety: CropVariety) {
    BlockStore.setAddEditCropVariety(cropVariety);
  }

  get submitLabel() {
    if (this.cropVariety && this.cropVariety.id && this.cropVariety.id != 0) {
      return 'Update';
    }
    return 'Add';
  }

  deleteDialog = false;

  updateCrop() {
    BlockStore.setAddEditCropVariety(this.cropVariety);
  }

  async onSubmit() {
    if (this.cropVariety.id && this.cropVariety.id != 0) {
      await BlockStore.updateCropVariety(this.cropVariety);
      this.$router.push({ name: 'CropVarietyList' });
      this.$q.notify({
        message: 'Crop variety updated successfully',
        type: 'positive'
      });
    } else {
      await BlockStore.createCropVariety(this.cropVariety);
      this.$router.push({ name: 'CropVarietyList' });
      this.$q.notify({
        message: 'Crop variety added successfully',
        type: 'positive'
      });
    }
    MapStore.setUpdateMapAlbums(true);
  }

  onReset() {
    this.cropVariety = JSON.parse(JSON.stringify(this.emptyCropVariety));
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.$router.push({ name: 'CropVarietyList' });
    });

    MapStore.updateMapSize();

    setTimeout(() => {
      MapStore.stopUpdateAnimation();
    }, 600);
  }

  async onDelete() {
    this.deleteDialog = false;
    if (this.cropVariety && this.cropVariety.id && this.cropVariety.id != 0) {
      BlockStore.deleteCrop(this.cropVariety.id);
      CommonStore.changeView('map');
    }
  }

  deleteCrop() {
    this.deleteDialog = true;
  }

  async created() {
    BlockStore.getAllCropTypes();
    this.cropVariety = JSON.parse(JSON.stringify(this.emptyCropVariety));
    BlockStore.setAddEditCropVariety(this.cropVariety);
    if (this.$route.params.cropVarietyId) {
      const cropVarietyId = Number(this.$route.params.cropVarietyId);
      await BlockStore.getCropVarietyById(cropVarietyId);
    }
  }
}
